(function () {
  let currentVideo = null;
  document.querySelectorAll('.card-gallery').forEach(function (card) {
    const video = card.querySelector('.product-hover-video');
    if (!video) return;
    card.addEventListener('mouseenter', function () {
      if (currentVideo && currentVideo !== video) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
      }
      currentVideo = video;
      video.play();
    });
    card.addEventListener('mouseleave', function () {
      video.pause();
      video.currentTime = 0;
    });
  });
})();